module.exports = __webpack_public_path__ + "img/brands-pan-girl.png?9a0cdc3ae40ce3ed7fa413a4e55c705f";